<section id="content">
  <div class="card">
    <div class="card-title">
      <h2>Customer Prospect Summary</h2>
    </div>
    <div class="prospect-summary-container">
      <p-accordion class="w-full" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
        <p-accordionTab header="Customer Prospect Summary Table">
          <div class="group-cont">
            <div class="table-responsive">
              <p-table #dtCustomerProspectSummary class="table" styleClass="ui-table-products" 
                tableStyleClass="table table-responsive"
                [value]="customerProspectSummary" 
                totalRecords="{{customerProspectSummary.length}}" 
                [rows]="10" 
                [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10, 25, 50]" 
                [paginator]="true" 
                [resizableColumns]="true"
                (onFilter)="onTableFilter($event)"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                <ng-template pTemplate="caption">
                  <div style="text-align: right">
                    <button type="button" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL"
                      (click)="exportSummaryExcel()" style="margin-top: 0.5em;margin-right: 0.5em;"
                      class="ui-button-success"></button>
                    <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" style="margin-top: 0.5em;"
                      (click)="exportSummaryPdf()" label="PDF" class="ui-button-warning"></button>
                  </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th>#</th>
                    <th pSortableColumn="customerName" width="33%">Customer Name
                      <p-sortIcon field="customerName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="prospectCount" width="33%">Prospect Count
                      <p-sortIcon field="prospectCount"></p-sortIcon>
                    </th>
                    <th pSortableColumn="activityCount" width="33%">Activity Count
                      <p-sortIcon field="activityCount"></p-sortIcon>
                    </th>
                  </tr>
                  <tr>
                    <th></th>
                    <th>
                      <!-- <p-columnFilter field="customerName" type="text" display="menu"
                        placeholder="Customer Name"></p-columnFilter> -->


                          <p-columnFilter
                                  field="customerName"
                                  matchMode="in"
                                  display="menu"
                                  [showMatchModes]="false"
                                  [showOperator]="false"
                                  [showAddButton]="false"
                                  [showMenu]="true">
                                
                                  <ng-template pTemplate="filter" let-filter="filterCallback">
                                      <p-multiSelect
                                        [options]="customerNamesOption"
                                        placeholder="Select Customer(s)"
                                        (onChange)="filter($event.value)"
                                        optionLabel="label"
                                        optionValue="value"
                                        display="chip"
                                        [filter]="true">
                                      </p-multiSelect>
                                  </ng-template>
                              </p-columnFilter>

                    </th>
                    <th>
                      <p-columnFilter field="prospectCount" type="numeric" display="menu"
                        placeholder="Prospect Count"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="activityCount" type="numeric" display="menu"
                        placeholder="Activity Count"></p-columnFilter>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-summary let-i="rowIndex">
                  <tr>
                    <td>{{i + 1}}</td>
                    <td>{{summary.customerName}}</td>
                    <td>{{summary.prospectCount}}</td>
                    <td>{{summary.activityCount}}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
    <div class="card">
      <div class="card-title">
        <h2>Customer Prospect Summary Chart</h2>
      </div>
      <div class="cont" id="chart-Container">
        <div class="p-grid" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
          <div class="p-col-3" style="flex: 1; padding: 0 5px;">
            <label for="dataType">Data Type:</label>
            <p-dropdown id="dataType" [options]="dataTypes" [(ngModel)]="selectedDataType"
              (onChange)="onDataTypeChange()" optionLabel="label" optionValue="value">
            </p-dropdown>
          </div>
          <div class="p-col-3" style="flex: 1; padding: 0 5px;">
            <label for="customerScope">Show:</label>
            <p-dropdown id="customerScope" [options]="customerScopeOptions" [(ngModel)]="selectedCustomerScope"
              (onChange)="onCustomerScopeChange()" optionLabel="label" optionValue="value">
            </p-dropdown>
          </div>
          <div class="p-col-3" style="flex: 1; padding: 0 5px;">
            <label for="customerCount">Count:</label>
            <p-inputNumber id="customerCount" [(ngModel)]="selectedCustomerCount" 
              (onInput)="onCustomerCountChange()" [disabled]="selectedCustomerScope === 'all'"
              [min]="1" [showButtons]="true" [useGrouping]="false" styleClass="w-full">
            </p-inputNumber>
          </div>
          <div class="p-col-3" style="flex: 1; padding-top: 15px;">
            <button pButton type="button" [label]="isSorted ? 'Sorted' : 'Sort'" 
              [icon]="isSorted ? 'pi pi-sort-amount-down' : 'pi pi-sort'" 
              (click)="onSortToggle()" class="p-button-secondary" style="width: 100%;">
            </button>
          </div>        </div>
        <div class="chart-container">
          <div class="chart-wrapper">
            <p-chart #customerProspectChart type="doughnut" [data]="customerProspectChartData" 
              [options]="customerProspectChartOptions" height="380px"></p-chart>
          </div>          <!-- Custom legend container -->
          <div class="custom-legend-container" *ngIf="customerProspectChartData && customerProspectChartData.labels">
            <h4 class="legend-title">Legend</h4>
            <div class="legend-items-container">              <div *ngFor="let label of customerProspectChartData.labels; let i = index" 
                  class="legend-item"
                  [class.legend-item-hidden]="isItemHidden(i)"
                  (click)="toggleLegendItem(i)">
                <span class="legend-color-box" 
                      [style.background-color]="customerProspectChartData.datasets[0].backgroundColor[i]"
                      [style.opacity]="isItemHidden(i) ? 0.4 : 1"></span>
                <span class="legend-label" [style.text-decoration]="isItemHidden(i) ? 'line-through' : 'none'">{{ label }}</span>
              </div>
            </div>
          </div>
        </div>        <div class="chart-buttons">
          <button type="button" (click)="exportChartAsImage()" class="ui-button-success export-button">
            Export Chart as PNG
          </button>
          <button type="button" (click)="exportChartAsPDF()" class="ui-button-success export-button">
            Export Chart as PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</section>